<script>
import {mapActions, mapGetters} from 'vuex';
import PgbaBaseComponent from '../../common/components/PgbaBaseComponent.vue';
export default {
    name: 'LandingContentBaseComponent',
    extends: PgbaBaseComponent,
    computed: {
        ...mapGetters('content', [
            'getBundle', // -> this.getBundle()
            'getContent', // -> this.getContent()
        ])
    },
    methods: {
        ...mapActions('content', [
            'initializeContent' // -> this.initializeContent()
        ]),
        routeToPath(routePath) {
            this.$router.push(routePath);
        },
        routeToName(routeName, params) {
            this.$router.push({name: routeName, params});
        }
    }
};
</script>
